/**
 * Parse a PostgreSQL INTERVAL string to a number of days (approximate).
 * Used to compute task end date for calendar rendering.
 * Examples: "7 days" → 7, "2 weeks" → 14, "1 month" → 30
 */
export const parsePSQLIntervalToDays = (interval) => {
  if (!interval) return 0
  const match = interval.match(/(\d+)\s+(day|week|month)s?/)
  if (!match) return 0
  const value = parseInt(match[1], 10)
  const unit = match[2]
  if (unit === 'week') return value * 7
  if (unit === 'month') return value * 30
  return value
}

/**
 * Format PostgreSQL INTERVAL to human-readable string
 * Examples: "7 days" → "1 week", "14 days" → "2 weeks", "3 days" → "3 days"
 */
export const formatPSQLInterval = (interval) => {
  if (!interval) return 'N/A'

  // PostgreSQL INTERVAL format: "X days" or "X weeks" or "X months"
  const match = interval.match(/(\d+)\s+(day|week|month)s?/)
  if (!match) return interval  // Return raw if format unknown

  const value = parseInt(match[1], 10)
  const unit = match[2]

  // Convert days to weeks if divisible by 7
  if (unit === 'day' && value % 7 === 0) {
    const weeks = value / 7
    return `${weeks} week${weeks !== 1 ? 's' : ''}`
  }

  // Return as-is
  return `${value} ${unit}${value !== 1 ? 's' : ''}`
}
